export class Department {

    id = 0;
    name = '';
    description = '';
}
